import React from 'react'
import { MultiSelect } from "react-multi-select-component";
import './MultiSelectOpt.css'
import downarrowIcon from '../../../images/downarrow.png'

const MultiSelectOpt = ({ name, options, value, onChange, labelledBy, hasSelectAll, disabled }) => {
    const RenderClearIcon = () => (
        <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#545A60', marginRight: '5px' }}>X</div>
    )
    return (
        <MultiSelect
            name={name}
            options={options}
            value={value}
            onChange={onChange}
            labelledBy={labelledBy}
            hasSelectAll={hasSelectAll}
            ArrowRenderer={() =>
                <div className="custom-arrow" >
                    <img src={downarrowIcon} alt="downarrowIcon" width={10} height={6} />
                </div>
            }
            closeOnSelect={false}
            ClearSelectedIcon={<RenderClearIcon />}
            ClearIcon={<RenderClearIcon />}
            disabled={disabled || false}
        />
    )
}

export default MultiSelectOpt
